import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import '../assets/css/app/overview.css';
import moment from 'moment';
import { END_DATE, START_DATE } from '../utility';

const DateComponent = (props) => {
  const startDate = props.startDate || moment().subtract(START_DATE, "days");
  const endDate = props.endDate || moment().subtract(END_DATE, "days");
  
  const referenceDate = moment().subtract(2, 'days');

  return (
    <DateRangePicker
      initialSettings={{ 
        startDate: startDate.format('YYYY-MM-DD'), 
        endDate: endDate.format('YYYY-MM-DD'),
        locale: {
          format: 'YYYY-MM-DD'
        },
        ranges: {
          'Today': [moment(), moment()],
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [referenceDate.clone().subtract(6, 'days'), referenceDate],
          'Last 30 Days': [referenceDate.clone().subtract(29, 'days'), referenceDate],
          'This Month': [referenceDate.clone().startOf('month'), referenceDate],
          'Last Month': [referenceDate.clone().subtract(1, 'month').startOf('month'), referenceDate.clone().subtract(1, 'month').endOf('month')]
        }
      }}
      onApply={props.handleChangeDate}
    >
      <div
        className="mx-datepicker mx-datepicker-range"
        style={{ width: "100%" }}
      >
        <div className="mx-input-wrapper">
          <input
            name="datetimes"
            type="text"
            autoComplete="off"
            className="mx-input"
            value={`${startDate.format('YYYY-MM-DD')} → ${endDate.format('YYYY-MM-DD')}`}
            onChange={() => {}}
          />
          <i className="mx-icon-calendar">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024"
              width="1em"
              height="1em"
            >
              <path d="M940.218 107.055H730.764v-60.51H665.6v60.51H363.055v-60.51H297.89v60.51H83.78c-18.617 0-32.581 13.963-32.581 32.581v805.237c0 18.618 13.964 32.582 32.582 32.582h861.09c18.619 0 32.583-13.964 32.583-32.582V139.636c-4.655-18.618-18.619-32.581-37.237-32.581zm-642.327 65.163v60.51h65.164v-60.51h307.2v60.51h65.163v-60.51h176.873v204.8H116.364v-204.8H297.89zM116.364 912.291V442.18H912.29v470.11H116.364z" />
            </svg>
          </i>
        </div>
      </div>
    </DateRangePicker>
  );
};

export default DateComponent;